<template>
    <v-app v-if="params_ok" id="app" :dark="false">
        <NotificationCenter />
        <GenericInputDialogFromAction />
        <OkCancelDialogFromAction />
        <ProgressComponent />
        <ButtonSelectionDialogFromAction />
        <EditHeader class="titlebar" />
        <TableEditor class="editor"
                     v-if="dataAvailable"
                     id="tableEditor"
                     v-on:currentScrollPosition="currentScrollPositionChange"
                     :initialScrollPosition="tableScrollPosition" />
        <div v-else class="editor"></div>
        <SettingsEditor />
        <InfoComponent />
        <EditFooter class="footer" />
    </v-app>
    <v-app v-else>
        Parameters missing
    </v-app>
</template>

<script>
    import EditHeader from "./EditHeader.vue";
    import EditFooter from "./EditFooter.vue";
    import TableEditor from "./TableEditor/TableEditor.vue";
    import SettingsEditor from "./SettingsEditor.vue";
    import NotificationCenter from "./NotificationCenter.vue";
    import OkCancelDialogFromAction from "./helpers/OkCancelDialogFromAction.vue";
    import GenericInputDialogFromAction from "./helpers/GenericInputDialogFromAction.vue";
    import ButtonSelectionDialogFromAction from "./helpers/ButtonSelectionDialogFromAction.vue";
    import ProgressComponent from "./helpers/ProgressComponent.vue";
    import InfoComponent from "./InfoComponent.vue";
    import { notificationMixin } from "../mixins/notificationMixin.js";
    import { CREATE_NEW_FILE } from "../../store/modules/uptData/constants";
    import { SET_REDIRECT_AFTER_SAVE } from "../../store/modules/settings/constants.js";
    import { NEW_GENERIC_INPUT_DIALOG } from "../../store/modules/genericInputDialog/constants.js";
    import eventBus from "../utils/eventBus";

    const _ = require("lodash");

    export default {
        name: "FileCreate",
        mixins: [notificationMixin],

        data: () => ({
            needUpdate: false,
            tableScrollPosition: null,
            params_ok: false,
            params: null
        }),

        components: {
            EditHeader,
            EditFooter,
            TableEditor,
            SettingsEditor,
            NotificationCenter,
            OkCancelDialogFromAction,
            GenericInputDialogFromAction,
            ButtonSelectionDialogFromAction,
            ProgressComponent,
            InfoComponent
        },

        computed: {
            dataAvailable() {
                return this.$store.state.uptData.dataAvailable && !this.needUpdate;
            },
        },

        created: function () {
            this.params = {
                filepath: _.get(this.$route.query, "filepath", false),
                redirectUrl: _.get(this.$route.query, "redirect_url", false),
                callbackUrl: _.get(this.$route.query, "callback_url", false)
            }
            this.params_ok = this.params.filepath && this.params.redirectUrl;
            if (this.params_ok && !this.params.filepath.toLowerCase().endsWith(".upt")) this.params.filepath += ".UPT";
            eventBus.$on("fullUpdate", args => this.update(args));
        },

        beforeDestroy: function () {
            eventBus.$off("fullUpdate", args => this.update(args));
        },

        mounted: function () {
            if (this.params_ok) this.createFile();
        },

        methods: {
            async createFile() {
                const dialogResult = await this.$store.dispatch(
                    NEW_GENERIC_INPUT_DIALOG,
                    {
                        title: "Create new pattern",
                        okText: "Create pattern",
                        icon: "add",
                        autofocus: "numberOfPicks",
                        content: [
                            {
                                id: "numberOfPicks",
                                type: "numberInput",
                                initialValue: "2",
                                inputLabel: "# of picks",
                                min: 2,
                                max: 100000
                            },
                            {
                                id: "numberOfJacquardHooks",
                                type: "numberInput",
                                initialValue: 0,
                                inputLabel: "# of jacquard hooks",
                                min: 0,
                                max: 3072,
                                createHint: v => {
                                    if (v % 8 === 0) {
                                    return "";
                                    } else {
                                    return `${v} is not dividable by 8. Will be set to ${Math.ceil(
                                        v / 8
                                    ) * 8}`;
                                    }
                                }
                            },
                            {
                                id: "numberOfShafts",
                                type: "numberInput",
                                initialValue: 0,
                                inputLabel: "# of shafts",
                                min: 0,
                                max: 32
                            }
                        ]
                    }
                )
                if (!dialogResult.cancelled && _.toNumber(dialogResult.numberOfPicks)) {
                    await this.$store.dispatch(CREATE_NEW_FILE, {
                        nrOfPicks: _.toNumber(dialogResult.numberOfPicks),
                        nrOfJacquardHooks: _.toNumber(dialogResult.numberOfJacquardHooks),
                        nrOfShafts: _.toNumber(dialogResult.numberOfShafts),
                        filename: this.params.filepath
                    });
                    this.$store.dispatch(SET_REDIRECT_AFTER_SAVE, {
                        filename: this.params.filepath,
                        customerId: null,
                        redirectUrl: this.params.redirectUrl,
                        callbackUrl: this.params.callbackUrl
                    });
                }
            },
            update(args) {
                if (!_.get(args, "retainScrollPosition")) {
                    this.tableScrollPosition = 0;
                }
                this.needUpdate = true;
                this.$nextTick(() => (this.needUpdate = false));
            },
            currentScrollPositionChange(pos) {
                this.tableScrollPosition = pos;
            }
        },
    }
</script>
